<template>
  <RCard class="orders">
    <EmailModal ref="modal" />

    <AgGrid :options="gridOptions" :row-data="filteredOrders">
      <template #header>
        <div class="text-subtitle-1 text-secondary-2 q-ml-sm q-mt-sm">ORDERS</div>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import { gridOptions } from './gridOptions'
// Libraries
import { cloneDeep } from 'lodash'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import EmailModal from '@/reusable/EmailModal'

export default {
  components: {
    AgGrid,
    EmailModal
  },

  mixins: [gridOptions],

  props: {
    orders: Array
  },

  computed: {
    filteredOrders() {
      if (!this.orders) return null

      const orders = cloneDeep(this.orders)
      return orders.filter(order => order.order_item)
    }
  },

  methods: {
    openModal(emailBatchId) {
      this.$refs.modal.show(emailBatchId)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.orders {
  @include table-with-no-filters;
}
</style>
